import { defaultAccountTypes, defaultPlaceholders } from 'utils/banks/banks';

export const banksListDeserializer = (item) => ({
  label: item.name,
  value: item.code,
  accountTypes: item.account_types ? item.account_types : defaultAccountTypes,
  agencyPlaceholder: item.agency_placeholder || defaultPlaceholders.agency,
  agencyRegex: item.agency_regex,
  accountPlaceholder: item.account_placeholder || defaultPlaceholders.account,
  accountRegex: item.account_regex,
});
